(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const wide = matchMedia('(min-width: 750px)');

    const load = (video) => {
      if (video.dataset.loaded) return;
      if (reduced.matches && video.dataset.ignoreReducedMotion !== 'true') return;
      if (!wide.matches && video.dataset.mobile !== 'true') return;
      video.dataset.loaded = 'true';
      video.src = video.dataset.src;
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      video.play().catch(() => {});
    };

    const init = (root = document) => {
      root.querySelectorAll('video[data-cine-video]').forEach((video) => {
        const start = () => load(video);
        if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 });
        else setTimeout(start, 800);
        wide.addEventListener('change', start);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keuzehulp"] && !Shopify.designMode) return;
  try {
    
  const TOTAL = 3;

  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    const form = root.querySelector('[data-keuzehulp-form]');
    const steps = Array.from(root.querySelectorAll('[data-keuzehulp-step]'));
    const results = root.querySelector('[data-keuzehulp-results]');
    const cards = Array.from(root.querySelectorAll('[data-keuzehulp-card]'));
    const empty = root.querySelector('[data-keuzehulp-empty]');
    const summary = root.querySelector('[data-keuzehulp-summary]');
    const back = root.querySelector('[data-keuzehulp-back]');
    const next = root.querySelector('[data-keuzehulp-next]');
    const nextLabel = root.querySelector('[data-keuzehulp-next-label]');
    const restart = root.querySelector('[data-keuzehulp-restart]');
    const counter = root.querySelector('[data-keuzehulp-counter]');
    const progress = root.querySelector('[data-keuzehulp-progress]');
    if (!form || !steps.length || !results) return;

    const labels = {
      next: root.dataset.nextLabel,
      show: root.dataset.showLabel,
      step: root.dataset.stepLabel,
      summary: root.dataset.summaryLabel,
    };
    const names = ['phase', 'cable', 'use'];
    let current = 1;

    root.classList.add('is-enhanced');

    const answers = () => {
      const data = new FormData(form);
      return Object.fromEntries(names.map((name) => [name, data.get(name) || 'any']));
    };

    const answered = (step) => Boolean(new FormData(form).get(names[step - 1]));

    const matches = (card, chosen) =>
      names.every((key) => {
        const tag = card.dataset[key];
        return !tag || tag === 'any' || chosen[key] === 'any' || tag === chosen[key];
      });

    const render = () => {
      steps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.keuzehulpStep) === current));
      if (progress) progress.style.setProperty('--keuzehulp-progress', `${(current / TOTAL) * 100}%`);
      if (counter) counter.textContent = labels.step.replace('[n]', current).replace('[total]', TOTAL);
      back.hidden = current === 1;
      nextLabel.textContent = current === TOTAL ? labels.show : labels.next;
      next.disabled = !answered(current);
    };

    const finish = () => {
      const chosen = answers();
      let visible = 0;
      cards.forEach((card) => {
        const show = matches(card, chosen);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;

      if (summary) {
        const picked = names
          .map((name) => form.querySelector(`input[name="${name}"]:checked`))
          .filter((input) => input && !input.hasAttribute('data-any'))
          .map((input) => input.closest('label').querySelector('.keuzehulp__option-label').textContent.trim());
        summary.textContent = picked.length ? `${labels.summary} ${picked.join(' · ')}` : '';
        summary.hidden = picked.length === 0;
      }

      root.classList.add('is-finished');
      restart.hidden = false;
      results.focus({ preventScroll: true });
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    const reset = () => {
      form.reset();
      cards.forEach((card) => { card.hidden = false; });
      root.classList.remove('is-finished');
      restart.hidden = true;
      current = 1;
      render();
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      render();
      // A tap on an option is an answer: move on without a second click.
      window.setTimeout(() => {
        if (current < TOTAL) {
          current += 1;
          render();
        } else {
          finish();
        }
      }, 220);
    });

    next.addEventListener('click', () => {
      if (!answered(current)) return;
      if (current < TOTAL) {
        current += 1;
        render();
      } else {
        finish();
      }
    });

    back.addEventListener('click', () => {
      if (current > 1) current -= 1;
      render();
    });

    restart.addEventListener('click', reset);
    form.addEventListener('submit', (event) => event.preventDefault());

    // Theme editor: selecting a recommendation block reveals the results with that card.
    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-keuzehulp-card]');
        if (!card) return;
        cards.forEach((item) => { item.hidden = false; });
        if (empty) empty.hidden = true;
        root.classList.add('is-finished');
        restart.hidden = false;
      });
    }

    render();
  };

  document.querySelectorAll('[data-keuzehulp]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-keuzehulp]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // "Toon meer" pagination: fetch the next page of this section, append its cards
  // to the grid, keep the URL and scroll position where they are.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-load-more-button]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const wrapper = button.closest('[data-load-more]');
    const grid = wrapper?.previousElementSibling?.matches('.product-grid') ? wrapper.previousElementSibling : wrapper?.parentElement.querySelector('.product-grid');
    if (!grid) return;

    button.setAttribute('aria-busy', 'true');
    try {
      const next = new URL(button.href, window.location.origin);
      next.searchParams.set('section_id', button.dataset.sectionId);
      const html = await fetch(next.toString()).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = doc.querySelectorAll('.product-grid > .product-grid__item');
      const fragment = document.createDocumentFragment();
      items.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      const shown = grid.querySelectorAll('.product-grid__item').length;
      const total = Number(button.dataset.total);
      const nextButton = doc.querySelector('[data-load-more-button]');
      const count = wrapper.querySelector('.product-grid__more-count');
      if (count) count.textContent = `${shown} / ${total}`;
      if (nextButton && shown < total) {
        button.href = nextButton.href;
        button.textContent = button.dataset.label.replace('[shown]', shown).replace('[total]', total);
      } else {
        wrapper.remove();
      }
    } catch (error) {
      window.location.href = button.href;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  const KEY = 'rjl-sticky-cta-dismissed';

  const init = (bar) => {
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';

    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(KEY) === '1';
    } catch (error) {
      dismissed = false;
    }

    const offset = Number(bar.dataset.offset) || 480;
    const desktop = window.matchMedia('(min-width: 990px)');
    let forced = false;
    let ticking = false;
    let atEnd = false;

    const update = () => {
      ticking = false;
      const show = forced || (!dismissed && !atEnd && !desktop.matches && window.scrollY > offset);
      bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
    };

    // The closing band and the footer carry the same calls to action. Standing on
    // top of them would show the visitor two of each in one viewport, so the bar
    // steps aside once the end of the page is reached.
    const endZones = document.querySelectorAll('[data-sticky-cta-end], footer.shopify-section');
    if (endZones.length && 'IntersectionObserver' in window) {
      const visible = new Set();
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          atEnd = visible.size > 0;
          update();
        },
        { rootMargin: '0px 0px -25% 0px' }
      );
      endZones.forEach((zone) => observer.observe(zone));
    }

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    desktop.addEventListener('change', update);
    update();

    bar.querySelector('[data-sticky-cta-close]')?.addEventListener('click', () => {
      dismissed = true;
      forced = false;
      update();
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (error) {
        // Storage can be unavailable in private modes; dismissal then lasts the page view.
      }
    });

    // In the theme editor the bar shows whenever the merchant selects it, so it can be edited.
    const section = bar.closest('.shopify-section');
    if (window.Shopify && window.Shopify.designMode && section) {
      section.addEventListener('shopify:section:select', () => {
        forced = true;
        update();
      });
      section.addEventListener('shopify:section:deselect', () => {
        forced = false;
        update();
      });
    }
  };

  document.querySelectorAll('[data-sticky-cta]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-sticky-cta]'));
  });

  } catch(e) { console.error(e); }
})();
})();
